export const RELATION = {
  PARENT: "parent",
  CHILD: "child"
};
